import {
  EMPTY_LIST,
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { ButtonIconSelectControl, ButtonSelect } from '../../Select'

import { ACTION_SELECT_DROPDOWN_STYLES } from './ActionSelect.constants'
import { getActionSelectControlButtonProps } from './ActionSelect.utils'
import { ActionSelectControlButton } from './ActionSelectControlButton'

import * as styles from './ActionSelect.module.css'

function ActionSelect({
  actions = EMPTY_LIST,
  className = styles.ActionSelect,
  controlProps: {
    Button: ControlButton = ActionSelectControlButton,
    className: controlClassName = styles.actionSelectControl,
    getButtonProps: getControlButtonProps = getActionSelectControlButtonProps,
    ...controlProps
  } = EMPTY_OBJECT,
  disabled,
  dropdownFloatingConfig: {
    dropdownStyles = ACTION_SELECT_DROPDOWN_STYLES,
    maxWidthByRef: dropdownMaxWidthByRef = false,
    placement: dropdownPlacement = FLOATING_ELEMENT_PLACEMENT.bottomEnd,
    ...dropdownFloatingConfig
  } = EMPTY_OBJECT,
  isInitiating,
  listProps,
  qaName,
  onClick,
  onClickAction,
}) {
  return (
    <ButtonSelect
      Control={ButtonIconSelectControl}
      className={className}
      controlProps={{
        ...controlProps,
        Button: ControlButton,
        buttonProps: {
          ...controlProps.buttonProps,
          isSkeleton: isInitiating || controlProps?.buttonProps?.isSkeleton,
        },
        className: controlClassName,
        getButtonProps: getControlButtonProps,
      }}
      disabled={disabled}
      dropdownFloatingConfig={{
        ...dropdownFloatingConfig,
        dropdownPlacement,
        dropdownStyles,
        maxWidthByRef: dropdownMaxWidthByRef,
      }}
      filter={null}
      listProps={{
        ...listProps,
        className: listProps?.className || styles.actionSelectList,
        headerProps: {
          ...listProps?.headerProps,
          Search: null,
        },
        itemProps: {
          ...listProps?.itemProps,
          contentProps: {
            ...listProps?.itemProps?.contentProps,
            infoProps: {
              ...listProps?.itemProps?.contentProps?.infoProps,
              contentTextProps: {
                ...listProps?.itemProps?.contentProps?.infoProps
                  ?.contentTextProps,
                textProps: {
                  ...listProps?.itemProps?.contentProps?.infoProps
                    ?.contentTextProps?.textProps,
                  isSecondary: true,
                },
              },
            },
          },
        },
      }}
      options={actions}
      qaName={qaName}
      onClick={onClick}
      onSelectItem={onClickAction}
    />
  )
}

export default ActionSelect
